module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-pow-logo.52b71f2.png";